/*
 *   Copyright (c) 2021 Busy Human LLC
 *   All rights reserved.
 *   This file, its contents, concepts, methods, behavior, and operation  (collectively the "Software") are protected by trade secret, patent,  and copyright laws. The use of the Software is governed by a license  agreement. Disclosure of the Software to third parties, in any form,  in whole or in part, is expressly prohibited except as authorized by the license agreement.
 */
export class DocumentRecycler {
    constructor(collection) {
        this.collection = collection;
        this.items = [];
    }
    reuseOrGenerate(id, fn) {
        var doc;
        var wrapper = this.wrapperById(id);
        if (!wrapper) {
            doc = fn(id);
            this.addAndRetain(doc);
            return doc;
        }
        else {
            this.retainWrapper(wrapper);
            return wrapper.doc;
        }
    }
    updateOrGenerate(snap, fn) {
        var doc;
        var wrapper = this.wrapperById(snap.id);
        if (!wrapper) {
            doc = fn(snap);
            this.addAndRetain(doc);
            return doc;
        }
        else {
            this.retainWrapper(wrapper);
            wrapper.doc.applySnapshot(snap);
            return wrapper.doc;
        }
    }
    wrapperById(id) {
        return this.items.find(wrapper => wrapper.doc.$id === id);
    }
    docById(id) {
        var wrapper = this.wrapperById(id);
        if (wrapper) {
            return wrapper.doc;
        }
        else {
            return undefined;
        }
    }
    addAndRetain(doc) {
        var existingDoc = this.wrapperById(doc.$id);
        if (existingDoc) {
            throw new Error(`DocumentRecycler.add: document already tracked ${doc.$id}`);
        }
        this.items.push({
            doc, count: 1
        });
    }
    retainWrapper(wrapper) {
        wrapper.count++;
    }
    retain(id) {
        var wrapper = this.wrapperById(id);
        if (wrapper) {
            this.retainWrapper(wrapper);
        }
        else {
            throw new Error(`DocumentRecycler.retain: no document ${id}`);
        }
    }
    release(id) {
        var doc = this.wrapperById(id);
        if (doc) {
            doc.count--;
            let index = this.items.indexOf(doc);
            this.items.splice(index, 1);
        }
        else {
            throw new Error(`DocumentRecycler.release: no document ${id}`);
        }
    }
}
//# sourceMappingURL=document-recycler.js.map